import { ApiACLRole } from "@incendium/api";
import { RouteProps } from "react-router-dom";
import { RouteNames } from "./routeNames";
import { Dashboard } from "Pages/Dashboard";
import ClientPage from "Pages/ClientPage";
import ProjectHomePage from "Pages/ProjectHomePage";
import AiChat from "features/ai/components/AiChat";
import { LocationsPage } from "Pages/LocationsPage";
import ClassificationsPage from "Pages/Audience/ClassificationsPage";
import AudiencesPage from "Pages/Audience/AudiencesPage";
import AudiencePage from "Pages/Audience/AudiencePage";
import LocationTagsPage from "Pages/Train/LocationTagsPage";
import EngagementPage from "Pages/Train/EngagementPage";
import AlertsPage from "Pages/Train/AlertsPage";
import AlertPage from "Pages/Train/AlertPage";
import LeadStatusesPage from "Pages/Train/LeadStatusesPage";
import LeadStatusPage from "Pages/Train/LeadStatusPage";
import LeadScoringPage from "Pages/Train/LeadScoringPage";
import EffectivenessPage from "Pages/Train/EffectivenessPage";
import PageviewEffectivenessRulesPage from "Pages/Train/PageviewEffectivenessRulesPage";
import SessionEffectivenessRulePage from "Pages/Train/SessionEffectivenessRulePage";
import { TrafficBucketsPage } from "Pages/Train/TrafficBucketsPage";
import TrafficBucketPage from "Pages/Train/TrafficBucketPage";
import DataManagerPage from "Pages/Connect/DataManagerPage";
import DataUploadPage from "Pages/Connect/DataUploadPage";
import AnalysePage from "Pages/Analyse/AnalysePage";
import UsersPage from "Pages/UserManagement/UsersPage";
import SamlTenantsPage from "Pages/UserManagement/SamlTenantsPage";
import ConversionsPage from "Pages/Train/ConversionsPage";
import DataConnectionsPage from "Pages/Connect/DataConnectionsPage";
import AudienceReportPage from "Pages/Analyse/Audiences";
import AudienceDeepDivePage from "Pages/Analyse/Audiences/AudienceDeepDivePage";
import ProductOverviewPage from "Pages/Analyse/Products/ProductOverviewPage";
import ProductReportPage from "Pages/Analyse/Products/ProductReportPage";
import ProductCategoryReportPage from "Pages/Analyse/Products/ProductCategoryReportPage";
import ProductsRankingPage from "Pages/Analyse/Products/ProductsRankingPage";
import ProductsPerformanceMapPage from "Pages/Analyse/Products/ProductsPerformanceMapPage";
import SingleUserDashboard from "Pages/Analyse/Users/SingleUserDashboard";
import UserDashboardPage from "Pages/Analyse/Users/UserDashboardPage";
import LocationOverviewPage from "Pages/Analyse/Content/LocationOverviewPage";
import ChartBuilderPage from "Pages/Analyse/ChartBuilderPage";
import ReportPage from "Pages/Analyse/ReportPage";
import ReportsPage from "Pages/Analyse/ReportsPage";
import ChartLibraryPage from "Pages/Analyse/ChartLibraryPage";
import MarketingPerformanceOrganicPage from "Pages/Analyse/MarketingPerformance/Organic";
import MarketingPerformancePaidMediaPage from "Pages/Analyse/MarketingPerformance/PaidMedia";
import MarketingPerformanceEmailPage from "Pages/Analyse/MarketingPerformance/EmailMarketing";
import MarketingPerformanceOrganicSocialPage from "Pages/Analyse/MarketingPerformance/OrganicSocial";
import JobsOverviewPage from "Pages/Analyse/Jobs/JobsOverviewPage";
import JobsReportPage from "Pages/Analyse/Jobs/JobsReportPage";
import JobsCategoryReportPage from "Pages/Analyse/Jobs/JobCategoryReportPage";
import JobsPerformanceMapPage from "Pages/Analyse/Jobs/JobPerfomanceMapPage";
import AudienceNewAndReturningPage from "Pages/Analyse/Audiences/New_and_returning";
import AudienceUserJourneyPage from "Pages/Analyse/Audiences/UserJourney";
import ContentPerformancePage from "Pages/Analyse/Content/ContentPerformancePage";
import JourneyExplorerPage from "Pages/Analyse/Content/JourneyExplorerPage";
import SalesFlowAnalysisPage from "Pages/Analyse/SalesFlowAnalysisPage";
import ComponentsPage from "Pages/Publish/ComponentsPage";
import ComponentPage from "Pages/Publish/ComponentPage";
import CampaignABOverviewPage from "Pages/Analyse/Content/CampaignABOverviewPage";
import SubdomainsPage from "Pages/Connect/SubdomainsPage";
import LightningLandersPage from "Pages/Publish/LightningLandersPage";
import ConversionLabPage from "Pages/Publish/ConversionLabPage";
import RezonatePage from "Pages/Publish/RezonatePage";
import LightningLandersReportPage from "Pages/Analyse/Content/LightningLandersReportPage";
import RezonateReportPage from "Pages/Analyse/Content/RezonateReportPage";
import ProductBrandReportPage from "Pages/Analyse/Products/ProductBrandReportPage";
import TrafficPage from "Pages/Train/TrafficPage";
import EcomInsightsPage from "Pages/Analyse/EcomInsights";
import StoreOverviewPage from "Pages/Analyse/StoreOverview/StoreOverviewPage";
import StoreProductPerformancePage from "Pages/Analyse/StoreOverview/StoreProductPerformancePage";
import StoreCustomerRetentionPage from "Pages/Analyse/StoreOverview/StoreCustomerRetentionPage";
import SiteOverview from "Pages/Analyse/QuickInsights/SiteOverview";
import ChannelInsights from "Pages/Analyse/QuickInsights/ChannelInsights";
import ContentInsights from "Pages/Analyse/QuickInsights/ContentInsights";
import DevicesInsights from "Pages/Analyse/QuickInsights/DevicesInsights";
import ReferralTrafficPage from "Pages/Analyse/MarketingPerformance/ReferralTrafficPage";
import SubscriptionPages from "Pages/SuperAdmin/SubscriptionPages";
import ContractsPage from "Pages/SuperAdmin/ContractsPage";
import MetricExplorerPage from "Pages/Analyse/Optimization/MetricExplorerPage";
import DimensionExplorerPage from "Pages/Analyse/Optimization/DimensionExplorerPage";
import ProductsPage from "Pages/SuperAdmin/ProductsPage";
import ProjectSubscriptionsPage from "Pages/SuperAdmin/ProjectSubscriptionsPage";
import AccountPage from "Pages/Account/AccountPage";
import AnalyticsLabelsPage from "Pages/SuperAdmin/AnalyticsLabelsPage";
import AICreditsPage from "Pages/SuperAdmin/AICreditsPage";
import VelocityPage from "Pages/Velocity/VelocityPage";
import VelocityReportPage from "Pages/Analyse/Optimization/VelocityReportPage";
import OnboardingPage from "Pages/SuperAdmin/OnboardingPage";
import NewProjectPage from "Pages/SuperAdmin/NewProjectPage";
import SharedComponentBlocksPage from "Pages/SuperAdmin/SharedComponentBlocksPage";
import SharedComponentBlockPage from "Pages/SuperAdmin/SharedComponentBlockPage";
import GetStartedPage from "Pages/GetStartedPage";
import CustomerValueCohortPage from "Pages/Analyse/CustomerValue/CustomerValueCohortPage";
import AttributionSetupPage from "Pages/Train/AttributionSetupPage";
import ExitPagesPage from "Pages/Analyse/Content/ExitPagesPage";
import ErrorPagesPage from "Pages/Analyse/Content/ErrorPagesPage";
import TimeAndDayInsightsPage from "Pages/Analyse/QuickInsights/TimeAndDayInsights";
import AdTimeAndDayInsightsPage from "Pages/Analyse/MarketingPerformance/PaidMedia/AdTimeAndDayInsightsPage";
import LightningLanderPage from "Pages/Publish/LightningLanderPage";
import AdPerformanceAnalysisPage from "Pages/Analyse/MarketingPerformance/PaidMedia/AdPerformanceAnalysisPage";
import ThankyouPage from "Pages/Account/ThankyouPage";
import LightningTemplatesPage from "Pages/Publish/LightningTemplatesPage";
import LightningTemplatePage from "Pages/Publish/LightningTemplatePage";
import LightningThemePage from "Pages/Publish/LightningThemePage";
import LanderTemplateBreadcrumbItem from "features/lightningLanders/components/LanderTemplateBreadcrumbItem";
import ChartTest from "Pages/Analyse/ChartTest";
import LightningBlocksPage from "Pages/Publish/LightningBlocksPage";
import LightningBlockPage from "Pages/Publish/LightningBlockPage";
import LightningComponentsPage from "Pages/Publish/LightningComponentsPage";
import LightningComponentPage from "Pages/Publish/LightningComponentPage";
import LanderBlockBreadcrumb from "features/lightningLanders/components/LanderBlockBreadcrumb";
import LanderComponentBreadcrumb from "features/lightningLanders/components/LanderComponentBreadcrumb";
import { SharedComponentBlockBreadcrumb } from "features/sharedComponentBlocks";
import AttributionExplorerPage from "Pages/Analyse/QuickInsights/AttributionExplorerPage";
import GeoExplorerPage from "Pages/Analyse/Audiences/GeoExplorerPage";
import ChannelPage from "Pages/Train/ChannelPage";
import { useCallback } from "react";
import GeneralSettingsPage from "Pages/GeneralSettingsPage";
import RezonateLandingPagesPage from "Pages/Publish/RezonateLandingPagesPage";
import MetaSignalsPage from "Pages/Publish/MetaSignalsPage";
import CampaignSplitOverviewPage from "Pages/Analyse/Content/CampaignSplitOverviewPage";
import IncrementalitySetupPage from "Pages/Optimize/IncrementalitySetupPage";
import IncrementalityTestsPage from "Pages/Optimize/IncrementalityTestsPage";
import AdsOverviewPage from "Pages/Analyse/MarketingPerformance/PaidMedia/AdsOverview";
import KeywordInsights from "Pages/Analyse/MarketingPerformance/PaidMedia/KeywordInsights";
import UtmExplorerPage from "Pages/Analyse/UtmExplorerPage";

export interface IProtectedRoute extends RouteProps {
  name: RouteNames;
  minRole?: ApiACLRole;
  withClients?: boolean;
  pageTitle?: string;
  pageSubTitle?: string;
  documentTitle?: string;
  withDatepicker?: boolean;
  withAttr?: boolean;
  withFromTo?: boolean;
  breadcrumbComponent?: React.ReactNode;
}

function useProtectedRoutes() {
  const routes = [
    {
      name: RouteNames.HOME,
      exact: true,
      path: "/",
      withClients: true,
      component: Dashboard,
      minRole: ApiACLRole.DOMAIN_ADMIN,
      pageTitle: "Manage Clients",
      pageSubTitle: "Create / Update or Delete Clients",
      documentTitle: "Manage",
    },
    {
      name: RouteNames.CLIENT_PAGE,
      exact: true,
      path: "/clients/:clientId",
      withClients: true,
      component: ClientPage,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      documentTitle: "Manage",
    },
    {
      name: RouteNames.PROJECT_PAGE,
      exact: true,
      path: "/clients/:clientId/projects/:projectId",
      withClients: true,
      component: ProjectHomePage,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      documentTitle: "Manage",
    },
    {
      name: RouteNames.AI_CHAT,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/ai-chat",
      withClients: true,
      component: AiChat,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      documentTitle: "Manage",
    },
    {
      name: RouteNames.SETTINGS,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/settings",
      withClients: true,
      component: GeneralSettingsPage,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      documentTitle: "Settings",
      pageTitle: "General Settings",
      pageSubTitle: "Configure your project settings",
    },
    {
      name: RouteNames.GET_STARTED,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/get-started",
      withClients: true,
      component: GetStartedPage,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      documentTitle: "Get Started",
    },
    {
      name: RouteNames.DATA_CONNECTIONS,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/connect/integrations",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: DataConnectionsPage,
      pageTitle: "Integrations",
      pageSubTitle: `Connect Incendium to external data sources to further enrich your analytics and analysis capabilities.`,
      documentTitle: "Connections",
    },
    {
      name: RouteNames.SUBDOMAINS,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/connect/subdomains",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: SubdomainsPage,
      documentTitle: "Connections",
      pageTitle: "Subdomain Management",
      pageSubTitle:
        "Effortlessly Create and Manage Custom Subdomains for Seamless Online Presence.",
    },
    {
      name: RouteNames.DATA_MANAGER,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/connect/data-manager",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: DataManagerPage,
      pageTitle: "Data Manager",
      pageSubTitle:
        "Upload / delete csv's to populate historic sales, add profit margins etc.",
      documentTitle: "Connections",
    },
    {
      name: RouteNames.DATA_UPLOAD,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/connect/data-manager/:ruleId",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: DataUploadPage,
      documentTitle: "Connections",
    },
    {
      name: RouteNames.LOCATIONS,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/train/locations",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: LocationsPage,
      documentTitle: "Train",
    },
    {
      name: RouteNames.CONVERSIONS,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/train/conversions",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: ConversionsPage,
      documentTitle: "Train",
      pageTitle: "Conversions",
    },
    {
      name: RouteNames.CHANNEL,
      path: "/clients/:clientId/projects/:projectId/train/traffic/channels/:channelId",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: ChannelPage,
      documentTitle: "Train",
    },
    {
      name: RouteNames.TRAFFIC_BUCKET,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/train/traffic/buckets/:bucketId",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: TrafficBucketPage,
      documentTitle: "Train",
    },
    {
      name: RouteNames.TRAFFIC,
      path: "/clients/:clientId/projects/:projectId/train/traffic",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: TrafficPage,
      documentTitle: "Traffic",
    },
    {
      name: RouteNames.TRAFFIC_CHANNELS,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/train/traffic/channels",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: TrafficPage,
      documentTitle: "Train",
    },
    {
      name: RouteNames.TRAFFIC_BUCKETS,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/train/traffic/buckets",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: TrafficBucketsPage,
      documentTitle: "Train",
    },
    {
      name: RouteNames.LOCATION_PAGE,
      path: "/clients/:clientId/projects/:projectId/train/locations/:locationId",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: LocationsPage,
      documentTitle: "Train",
    },
    {
      name: RouteNames.LEAD_SCORING_ENGAGEMENT,
      path: "/clients/:clientId/projects/:projectId/train/lead-scoring/:engagementId",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: EngagementPage,
      documentTitle: "Train",
    },
    {
      name: RouteNames.LEAD_SCORING,
      path: "/clients/:clientId/projects/:projectId/train/lead-scoring",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: LeadScoringPage,
      documentTitle: "Train",
    },
    {
      name: RouteNames.EFFECTIVENESS_PAGEVIEWS,
      path: "/clients/:clientId/projects/:projectId/train/effectiveness/pageviews/:ruleId",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: PageviewEffectivenessRulesPage,
      documentTitle: "Train",
    },
    {
      name: RouteNames.EFFECTIVENESS_SESSIONS,
      path: "/clients/:clientId/projects/:projectId/train/effectiveness/sessions/:ruleId",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: SessionEffectivenessRulePage,
      documentTitle: "Train",
    },
    {
      name: RouteNames.EFFECTIVENESS,
      path: "/clients/:clientId/projects/:projectId/train/effectiveness",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: EffectivenessPage,
      documentTitle: "Train",
    },
    {
      name: RouteNames.ATTRIBUTION_SETUP,
      path: "/clients/:clientId/projects/:projectId/train/attribution-setup",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: AttributionSetupPage,
      documentTitle: "Train",
      pageTitle: "Attribution Setup",
      pageSubTitle: "Adjust your EBA attribution weights",
    },
    {
      name: RouteNames.ALERT,
      path: "/clients/:clientId/projects/:projectId/train/alerts/:alertId",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: AlertPage,
      documentTitle: "Train",
    },
    {
      name: RouteNames.ALERTS,
      path: "/clients/:clientId/projects/:projectId/train/alerts",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: AlertsPage,
      documentTitle: "Train",
    },
    {
      name: RouteNames.LEAD_STATUS,
      path: "/clients/:clientId/projects/:projectId/train/funnel-stages/:leadStatusRuleId",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: LeadStatusPage,
      documentTitle: "Train",
      pageTitle: "Funnel Stage Setup",
    },
    {
      name: RouteNames.LEAD_STATUSES,
      path: "/clients/:clientId/projects/:projectId/train/funnel-stages",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: LeadStatusesPage,
      documentTitle: "Train",
    },
    {
      name: RouteNames.LOCATION_TAGS,
      path: "/clients/:clientId/projects/:projectId/train/location-tags",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: LocationTagsPage,
      documentTitle: "Train",
      pageTitle: "Location Tags",
      pageSubTitle:
        "Location Tags can be used to group locations together to use in analytics",
    },
    {
      name: RouteNames.TRAITS,
      path: "/clients/:clientId/projects/:projectId/audience/traits",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: ClassificationsPage,
      documentTitle: "Audiences",
      pageTitle: "Traits",
      pageSubTitle: `Traits are a way of assigning an attribute to a lead and a value to that attribute, based on their actions and behavior. You can then use combinations of these attributes and values to build audience segments for analytics or personalization.`,
    },
    {
      name: RouteNames.AUDIENCES,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/audience/audiences",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: AudiencesPage,
      pageTitle: "Manage Audiences",
      pageSubTitle:
        "Create rules to group users togther basd on their traits and interactions.",
      documentTitle: "Audiences",
    },
    {
      name: RouteNames.AUDIENCE,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/audience/audiences/:audienceid",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: AudiencePage,
      documentTitle: "Audiences",
    },
    {
      name: RouteNames.ANALYSE,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse",
      withClients: true,
      component: AnalysePage,
      documentTitle: "Analytics",
    },
    {
      name: RouteNames.CUSTOM_REPORT,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/custom-report",
      withClients: true,
      component: AnalysePage,
      documentTitle: "Analytics",
    },
    {
      name: RouteNames.SITE_OVERVIEW,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/site-overview",
      withClients: true,
      component: SiteOverview,
      documentTitle: "Analytics",
      pageTitle: "Site Overview",
      withDatepicker: true,
      withAttr: false,
      withFromTo: true,
    },
    {
      name: RouteNames.ATTRIBUTION_EXPLORER,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/attribution-explorer",
      withClients: true,
      component: AttributionExplorerPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withAttr: false, // has its own attribution switcher
      withFromTo: true,
      pageTitle: "Attribution Explorer",
    },
    {
      name: RouteNames.TRAFFIC_CAMPAIGNS,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/traffic-&-campaigns",
      withClients: true,
      component: ChannelInsights,
      documentTitle: "Analytics",
      pageTitle: "Traffic & Campaigns",
      withDatepicker: true,
      withAttr: true,
      withFromTo: true,
    },
    {
      name: RouteNames.LANDING_PAGES,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/landing-pages",
      withClients: true,
      component: ContentInsights,
      documentTitle: "Analytics",
      pageTitle: "Landing Pages",
      withDatepicker: true,
      withFromTo: true,
      withAttr: true,
    },
    {
      name: RouteNames.DEVICES,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/devices",
      withClients: true,
      component: DevicesInsights,
      documentTitle: "Analytics",
      pageTitle: "Devices",
      withDatepicker: true,
      withAttr: false,
      withFromTo: true,
    },
    {
      name: RouteNames.TIME_AND_DAY,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/time-and-day",
      withClients: true,
      component: TimeAndDayInsightsPage,
      documentTitle: "Analytics",
      pageTitle: "Time & Day Insights",
      withDatepicker: true,
      withAttr: false,
      withFromTo: true,
    },
    {
      name: RouteNames.STORE_OVERVIEW,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/store-overview",
      withClients: true,
      component: StoreOverviewPage,
      documentTitle: "Analytics",
      pageTitle: "Store Overview",
      withDatepicker: true,
      withAttr: false,
      withFromTo: true,
    },
    {
      name: RouteNames.STORE_PRODUCT_PERFORMANCE,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/store-product-performance",
      withClients: true,
      component: StoreProductPerformancePage,
      documentTitle: "Analytics",
      pageTitle: "Product Performance",
      pageSubTitle:
        "Analyze product performance and identify top opportunities for growth",
      withDatepicker: true,
      withAttr: false,
      withFromTo: true,
    },
    {
      name: RouteNames.STORE_CUSTOMER_RETENTION,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/store-customer-retention",
      withClients: true,
      component: StoreCustomerRetentionPage,
      documentTitle: "Analytics",
      pageTitle: "Customer Retention",
      pageSubTitle:
        "Understand repeat purchase behaviour and how quickly customers return",
      withDatepicker: true,
      withAttr: false,
      withFromTo: true,
    },
    {
      name: RouteNames.ECOM_INSIGHTS,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/quick-insights-ecom",
      withClients: true,
      component: EcomInsightsPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withAttr: true,
      withFromTo: true,
    },
    {
      name: RouteNames.ECOM_INSIGHTS,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/quick-insights-ecom/:insight",
      withClients: true,
      component: EcomInsightsPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withAttr: true,
      withFromTo: true,
    },
    {
      name: RouteNames.PAID_MEDIA,
      exact: true,
      path: "/clients/:clientId/projects/:projectIdm/analyse/standard-reports/paid-media",
      withClients: true,
      component: MarketingPerformancePaidMediaPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withAttr: true,
      withFromTo: true,
    },
    {
      name: RouteNames.AD_PERFORMANCE_ANALYSIS,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/paid-media/campaign-drilldown",
      withClients: true,
      component: AdPerformanceAnalysisPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withAttr: true,
      withFromTo: true,
      pageTitle: "Campaign Drilldown",
      pageSubTitle: "Compare & deep dive paid activity in 1 view",
    },
    {
      name: RouteNames.AD_TIME_AND_DAY,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/paid-media/ad-time-and-day",
      withClients: true,
      component: AdTimeAndDayInsightsPage,
      documentTitle: "Analytics",
      pageTitle: "Ad Time & Day Insights",
      withDatepicker: true,
      withAttr: false,
      withFromTo: true,
    },
    {
      name: RouteNames.ADS_OVERVIEW,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/paid-media/ads-overview",
      withClients: true,
      component: AdsOverviewPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withAttr: true,
      withFromTo: true,
      pageTitle: "Ads",
    },
    {
      name: RouteNames.UTM_EXPLORER,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/utm-explorer",
      withClients: true,
      component: UtmExplorerPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withAttr: true,
      withFromTo: true,
      pageTitle: "UTM Explorer",
    },
    {
      name: RouteNames.KEYWORDS,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/paid-media/keywords",
      withClients: true,
      component: KeywordInsights,
      documentTitle: "Analytics",
      withDatepicker: true,
      withAttr: true,
      withFromTo: true,
      pageTitle: "Keywords",
    },
    {
      name: RouteNames.PAID_MEDIA,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/paid-media/:insight",
      withClients: true,
      component: MarketingPerformancePaidMediaPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withAttr: true,
      withFromTo: true,
    },

    {
      name: RouteNames.ORGANIC,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/organic-&-owned-media/organic",
      withClients: true,
      component: MarketingPerformanceOrganicPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withAttr: true,
      withFromTo: true,
    },
    {
      name: RouteNames.ORGANIC,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/organic-&-owned-media/organic/:insight",
      withClients: true,
      component: MarketingPerformanceOrganicPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withAttr: true,
      withFromTo: true,
    },
    {
      name: RouteNames.EMAIL_PERFORMANCE,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/organic-&-owned-media/email-performance",
      withClients: true,
      component: MarketingPerformanceEmailPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withAttr: true,
      withFromTo: true,
    },
    {
      name: RouteNames.EMAIL_PERFORMANCE,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/organic-&-owned-media/email-performance/:insight",
      withClients: true,
      component: MarketingPerformanceEmailPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withAttr: false,
      withFromTo: true,
      pageTitle: "Email Marketing Performance",
    },
    {
      name: RouteNames.ORGANIC_SOCIAL,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/organic-&-owned-media/organic-social",
      withClients: true,
      component: MarketingPerformanceOrganicSocialPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withAttr: true,
      withFromTo: true,
    },
    {
      name: RouteNames.ORGANIC_SOCIAL,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/organic-&-owned-media/organic-social/:insight",
      withClients: true,
      component: MarketingPerformanceOrganicSocialPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withAttr: false,
      withFromTo: true,
      pageTitle: "Organic Social Performance",
    },
    {
      name: RouteNames.REFERRAL_TRAFFIC,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/organic-&-owned-media/referral-traffic",
      withClients: true,
      component: ReferralTrafficPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withAttr: false,
      withFromTo: true,
      pageTitle: "Referral Traffic",
    },

    {
      name: RouteNames.GEO_EXPLORER,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/geo-explorer",
      withClients: true,
      component: GeoExplorerPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withAttr: false,
      withFromTo: true,
      pageTitle: "Geo Explorer",
    },
    {
      name: RouteNames.AUDIENCE_COMPARISON,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/audience-comparison",
      withClients: true,
      component: AudienceReportPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withAttr: true,
      withFromTo: true,
    },
    {
      name: RouteNames.AUDIENCE_COMPARISON,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/audience-comparison/:insight",
      withClients: true,
      component: AudienceReportPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withAttr: true,
      withFromTo: true,
    },
    {
      name: RouteNames.AUDIENCE_DEEP_DIVE,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/audience-deep-dive",
      withClients: true,
      component: AudienceDeepDivePage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withAttr: false,
      withFromTo: true,
      pageTitle: "Audience Deep Dive",
    },
    {
      name: RouteNames.AUDIENCE_NEW_RETURNING,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/audience-insights-new-and-returning/",
      withClients: true,
      component: AudienceNewAndReturningPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withAttr: false,
      withFromTo: true,
    },
    {
      name: RouteNames.AUDIENCE_NEW_RETURNING,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/audience-insights-new-and-returning/:insight",
      withClients: true,
      component: AudienceNewAndReturningPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withAttr: false,
      withFromTo: true,
    },
    {
      name: RouteNames.AUDIENCE_USER_JOURNEY,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/audience-insights-user-journey/",
      withClients: true,
      component: AudienceUserJourneyPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withAttr: false,
      withFromTo: true,
    },
    {
      name: RouteNames.AUDIENCE_USER_JOURNEY,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/audience-insights-user-journey/:insight",
      withClients: true,
      component: AudienceUserJourneyPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withAttr: false,
      withFromTo: true,
    },
    {
      name: RouteNames.PRODUCTS_OVERVIEW,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/products-overview",
      withClients: true,
      component: ProductOverviewPage,
      documentTitle: "Analytics",
      pageTitle: "Products Overview",
      pageSubTitle: "Compare product performance with selected time period",
      withDatepicker: true,
      withFromTo: true,
    },
    {
      name: RouteNames.PRODUCT_DEEP_DIVE,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/product-deep-dive",
      withClients: true,
      component: ProductReportPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withFromTo: true,
    },
    {
      name: RouteNames.PRODUCT_CATEGORY_DEEP_DIVE,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/product-category-deep-dive",
      withClients: true,
      component: ProductCategoryReportPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withFromTo: true,
    },
    {
      name: RouteNames.PRODUCT_BRAND_DEEP_DIVE,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/product-brand-deep-dive",
      withClients: true,
      component: ProductBrandReportPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withFromTo: true,
    },
    {
      name: RouteNames.PRODUCT_PERFORMANCE_ANALYSIS,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/product-performance-analysis",
      withClients: true,
      component: ProductsRankingPage,
      documentTitle: "Optimization",
      withDatepicker: true,
      withFromTo: true,
      pageTitle: "Product Performance Analysis",
    },
    {
      name: RouteNames.PRODUCTS_PERFORMANCE_MAP,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/products-performance-map",
      withClients: true,
      component: ProductsPerformanceMapPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withFromTo: true,
    },
    {
      name: RouteNames.JOBS_OVERVIEW,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/jobs-overview",
      withClients: true,
      component: JobsOverviewPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withFromTo: true,
      pageTitle: "Jobs Overview",
      pageSubTitle: "Compare job performance with last equal time period",
    },
    {
      name: RouteNames.JOBS_DEEP_DIVE,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/jobs-deep-dive",
      withClients: true,
      component: JobsReportPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withFromTo: true,
    },
    {
      name: RouteNames.JOBS_CATEGORY_DEEP_DIVE,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/jobs-category-deep-dive",
      withClients: true,
      component: JobsCategoryReportPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withFromTo: true,
    },
    {
      name: RouteNames.JOBS_PERFORMANCE_MAP,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/jobs-performance-map",
      withClients: true,
      component: JobsPerformanceMapPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withFromTo: true,
    },
    {
      name: RouteNames.USER_DASHBOARD_SINGLE,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/user-dashboard/:leadid",
      withClients: true,
      component: SingleUserDashboard,
      documentTitle: "Analytics",
      pageTitle: "Single User Dashboard",
      pageSubTitle: "Examine the journey of this user",
    },
    {
      name: RouteNames.USER_DASHBOARD,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/user-dashboard",
      withClients: true,
      component: UserDashboardPage,
      documentTitle: "Analytics",
      pageTitle: "User Dashboard",
    },
    {
      name: RouteNames.LOCATIONS_OVERVIEW,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/locations-overview",
      withClients: true,
      component: LocationOverviewPage,
      pageTitle: "Locations Overview",
      pageSubTitle: "See which locations generate the most engagement",
      documentTitle: "Analytics",
      withDatepicker: true,
      withFromTo: true,
    },
    {
      name: RouteNames.EXIT_PAGES,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/exit-pages",
      withClients: true,
      component: ExitPagesPage,
      pageTitle: "Exit Pages",
      documentTitle: "Analytics",
      withDatepicker: true,
      withFromTo: true,
    },
    {
      name: RouteNames.ERROR_PAGES,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/error-pages",
      withClients: true,
      component: ErrorPagesPage,
      pageTitle: "Error Pages",
      documentTitle: "Analytics",
      withDatepicker: true,
      withFromTo: true,
    },
    {
      name: RouteNames.CONTENT_PERFORMANCE_ANALYSIS,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/content-performance-analysis",
      withClients: true,
      component: ContentPerformancePage,
      documentTitle: "Optimization",
      withDatepicker: true,
      withAttr: false,
      withFromTo: true,
    },
    {
      name: RouteNames.METRIC_EXPLORER,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/explorer",
      withClients: true,
      component: MetricExplorerPage,
      documentTitle: "Optimization",
      withDatepicker: true,
      withFromTo: true,
      pageTitle: "Metric Explorer",
      pageSubTitle: "Explore your data and uncover insights",
      withAttr: true,
    },
    {
      name: RouteNames.DIMENSION_EXPLORER,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/dimension-explorer",
      withClients: true,
      component: DimensionExplorerPage,
      documentTitle: "Optimization",
      withDatepicker: true,
      withFromTo: true,
      pageTitle: "Dimension Explorer",
      pageSubTitle: "Explore your data and uncover insights",
      withAttr: true,
    },
    {
      name: RouteNames.JOURNEY_EXPLORER,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/journey-explorer",
      withClients: true,
      component: JourneyExplorerPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withAttr: false,
      withFromTo: true,
      pageTitle: "User Journey Explorer",
    },
    {
      name: RouteNames.CUSTOMER_VALUE_COHORT,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/customer-value/cohort",
      withClients: true,
      component: CustomerValueCohortPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withAttr: true,
      withFromTo: true,
      pageTitle: "Customer Value",
    },
    {
      name: RouteNames.AB_TESTING_LAB,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/optimization/ab-testing-lab",
      withClients: true,
      component: CampaignABOverviewPage,
      documentTitle: "Optimization",
      withDatepicker: true,
      withFromTo: true,
      pageTitle: "A/B Testing Report",
      pageSubTitle: "Variant vs. Control AB Test Results",
    },
    {
      name: RouteNames.SPLIT_TESTING_LAB,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/optimization/split-test-lab",
      withClients: true,
      component: CampaignSplitOverviewPage,
      documentTitle: "Optimization",
      withDatepicker: true,
      withFromTo: true,
      pageTitle: "Split Test Report",
      pageSubTitle: "Split Campaign Performance Results",
    },
    {
      name: RouteNames.VELOCITY,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/velocity",
      withClients: true,
      component: VelocityPage,
      documentTitle: "Optimization",
      pageTitle: "Velocity",
      pageSubTitle: "Setup your Velocity Campaigns",
    },
    {
      name: RouteNames.VELOCITY_REPORT,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/optimization/velocity",
      withClients: true,
      component: VelocityReportPage,
      documentTitle: "Optimization",
      pageTitle: "Velocity Results",
      pageSubTitle: "See how Velocity is Impacting your Performance",
      withDatepicker: true,
      withAttr: true,
      withFromTo: true,
    },
    {
      name: RouteNames.LIGHTNING_LANDING_PAGES_REPORT,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/optimization/lightning-landing-pages",
      withClients: true,
      component: LightningLandersReportPage,
      documentTitle: "Optimization",
      withDatepicker: true,
      withAttr: true,
      withFromTo: true,
    },
    {
      name: RouteNames.LIGHTNING_LANDING_PAGE,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/optimization/lightning-landing-pages/:landerId",
      withClients: true,
      component: LightningLandersReportPage,
      documentTitle: "Optimization",
      withDatepicker: true,
      withAttr: true,
      withFromTo: true,
    },
    {
      name: RouteNames.PERSONALIZATION_REPORT,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/optimization/personalization-report",
      withClients: true,
      component: RezonateReportPage,
      documentTitle: "Optimization",
      withDatepicker: true,
      withAttr: true,
      withFromTo: true,
    },
    {
      name: RouteNames.PERSONALIZATION,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/optimization/personalization-report/:personalisationId",
      withClients: true,
      component: RezonateReportPage,
      pageTitle: "Rezonate Campaigns",
      pageSubTitle: "Personalization Performance Results",
      documentTitle: "Optimization",
      withDatepicker: true,
      withAttr: true,
      withFromTo: true,
    },
    {
      name: RouteNames.AB_TESTING_LAB_PUBLISH,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/optimization/ab-testing-lab",
      withClients: true,
      component: CampaignABOverviewPage,
      documentTitle: "Optimization",
      withDatepicker: true,
      withAttr: true,
      withFromTo: true,
      pageTitle: "Conversion Lab Report",
      pageSubTitle: "Variant vs. Control AB Test Results",
    },
    {
      name: RouteNames.FUNNEL_ANALYSIS,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/funnel-analysis/:crKey",
      withClients: true,
      component: SalesFlowAnalysisPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withFromTo: true,
      pageTitle: "Funnel Analysis",
    },
    {
      name: RouteNames.FUNNEL_ANALYSIS,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/standard-reports/funnel-analysis",
      withClients: true,
      component: SalesFlowAnalysisPage,
      documentTitle: "Analytics",
      withDatepicker: true,
      withFromTo: true,
      pageTitle: "Funnel Analysis",
    },
    {
      name: RouteNames.CHART_LIBRARY,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/reports/chart-library",
      withClients: true,
      minRole: ApiACLRole.ANALYTICS_ADMIN,
      component: ChartLibraryPage,
      documentTitle: "Reporting",
    },
    {
      name: RouteNames.CHART_BUILDER,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/reports/chart-library/:chartId",
      withClients: true,
      minRole: ApiACLRole.ANALYTICS_ADMIN,
      component: ChartBuilderPage,
      documentTitle: "Reporting",
      withDatepicker: true,
      withFromTo: true,
      withAttr: true,
    },
    {
      name: RouteNames.CHART_TEST,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/reports/chart-test",
      withClients: true,
      minRole: ApiACLRole.ANALYTICS_ADMIN,
      component: ChartTest,
      documentTitle: "Reporting",
      withDatepicker: true,
      withFromTo: true,
      pageTitle: "AI Chart Tester",
    },
    {
      name: RouteNames.REPORTS,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/reports",
      withClients: true,
      component: ReportsPage,
      pageTitle: "Manage Custom Reports",
      pageSubTitle:
        "Create / Edit & Delete Custom reports or pin them to your Analyse Homepage.",
      documentTitle: "Reporting",
    },
    {
      name: RouteNames.REPORT,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/analyse/reports/:reportId",
      withClients: true,
      component: ReportPage,
      documentTitle: "Reporting",
      withFromTo: true,
      withAttr: true,
      // withDatepicker: true, // although true, we set in the page component, as need to check if should be read only
    },

    {
      name: RouteNames.AB_TESTING_LAB_PUBLISH,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/publish/ab-testing-lab",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: ConversionLabPage,
      pageTitle: "A/b Testing",
      documentTitle: "Publish",
    },
    {
      name: RouteNames.PERSONALIZATION,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/publish/personalization",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: RezonatePage,
      documentTitle: "Publish",
      pageTitle: "Personalization",
    },
    {
      name: RouteNames.COMPONENTS,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/publish/components",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: ComponentsPage,
      pageTitle: "Components",
      documentTitle: "Publish",
    },
    {
      name: RouteNames.COMPONENT,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/publish/components/:componentId",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: ComponentPage,
      documentTitle: "Publish",
    },
    {
      name: RouteNames.LIGHTNING_LANDING_TEMPLATES,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/publish/lightning-landing-templates",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: LightningTemplatesPage,
      documentTitle: "Publish",
      pageTitle: "Landing Template Management",
      pageSubTitle:
        "Create and Manage Your Lightning Lander Templates for future use.",
    },
    {
      name: RouteNames.LIGHTNING_LANDING_TEMPLATE,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/publish/lightning-landing-templates/:componentId",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: LightningTemplatePage,
      documentTitle: "Publish",
      pageTitle: "Landing Template Management",
      pageSubTitle:
        "Create and Manage Your Lightning Lander Templates for future use.",
      breadcrumbComponent: <LanderTemplateBreadcrumbItem />,
    },
    {
      name: RouteNames.LIGHTNING_LANDING_BLOCKS,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/publish/lightning-landing-blocks",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: LightningBlocksPage,
      documentTitle: "Publish",
      pageTitle: "Landing Blocks Management",
      pageSubTitle:
        "Create and Manage Your reusable Blocks to use in your Lightning Landing Pages.",
    },
    {
      name: RouteNames.LIGHTNING_LANDING_BLOCK,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/publish/lightning-landing-blocks/:componentId",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: LightningBlockPage,
      documentTitle: "Publish",
      pageTitle: "Landing Block Management",
      pageSubTitle:
        "Create and Manage Your Lightning Lander Blocks for future use.",
      breadcrumbComponent: <LanderBlockBreadcrumb />,
    },
    {
      name: RouteNames.LIGHTNING_LANDING_COMPONENTS,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/publish/lightning-landing-components",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: LightningComponentsPage,
      documentTitle: "Publish",
      pageTitle: "Landing Components Management",
      pageSubTitle:
        "Create and manage reusable components (product cards, buttons, headers, etc.) to use in blocks and pages.",
    },
    {
      name: RouteNames.LIGHTNING_LANDING_COMPONENT,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/publish/lightning-landing-components/:componentId",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: LightningComponentPage,
      documentTitle: "Publish",
      pageTitle: "Landing Component",
      pageSubTitle: "Edit your landing component.",
      breadcrumbComponent: <LanderComponentBreadcrumb />,
    },
    {
      name: RouteNames.LIGHTNING_LANDING_THEME,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/publish/lightning-landing-theme",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: LightningThemePage,
      documentTitle: "Publish",
      pageTitle: "Landing Theme Management",
      pageSubTitle:
        "Create and Manage Your Lightning Lander Theme for future use.",
    },
    {
      name: RouteNames.LIGHTNING_LANDING_PAGES,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/publish/lightning-landing-pages",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: LightningLandersPage,
      documentTitle: "Publish",
      pageTitle: "Landing Pages Management",
      pageSubTitle:
        "Create and Manage Your Lightning Landing Pages, Link Them to a Subdomain, and Track Performance.",
    },
    {
      name: RouteNames.LIGHTNING_LANDING_PAGE,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/publish/lightning-landing-pages/:componentId",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: LightningLanderPage,
      documentTitle: "Publish",
      pageTitle: "Landing Pages Management",
      pageSubTitle:
        "Create and Manage Your Lightning Landing Pages, Link Them to a Subdomain, and Track Performance.",
    },
    {
      name: RouteNames.REZONATE_META_LANDING_PAGES,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/optimize/rezonate/landing-pages",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: RezonateLandingPagesPage,
      documentTitle: "Optimize",
      pageTitle: "Smart Links & Landing Pages",
      pageSubTitle:
        "Manage smart links for your Meta Ads with automatic inheritance. Link campaigns, ad sets, and ads to Rezonate landing pages or custom URLs, or let Incendium AI generate landing pages for multiple ads at once.",
    },
    {
      name: RouteNames.SIGNALS_META_LANDING_PAGES,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/optimize/signals/meta",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: MetaSignalsPage,
      documentTitle: "Optimize",
      pageTitle: "Meta Signal Management",
    },
    {
      name: RouteNames.INCREMENTALITY_TESTS,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/optimize/incrementality/tests",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: IncrementalityTestsPage,
      documentTitle: "Optimize",
      pageTitle: "Incrementality Tests",
      pageSubTitle: "Create and manage geo incrementality tests",
    },
    {
      name: RouteNames.INCREMENTALITY_SETUP,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/optimize/incrementality/tests/:testId",
      withClients: true,
      minRole: ApiACLRole.PROJECT_OBSERVER,
      component: IncrementalitySetupPage,
      documentTitle: "Optimize",
      pageTitle: "Incrementality Test Setup",
      pageSubTitle: "Set up your geo incrementality test",
    },
    {
      name: RouteNames.USERS,
      exact: false,
      path: "/admin/users",
      withClients: true,
      component: UsersPage,
      documentTitle: "Super Admin",
      minRole: ApiACLRole.SUPER_ADMIN,
    },
    {
      name: RouteNames.SSO_TENANTS,
      exact: false,
      path: "/admin/sso-tenants",
      withClients: true,
      component: SamlTenantsPage,
      documentTitle: "Super Admin",
      minRole: ApiACLRole.SUPER_ADMIN,
    },
    {
      name: RouteNames.SUBSCRIPTIONS,
      exact: true,
      path: "/admin/subscriptions",
      withClients: true,
      minRole: ApiACLRole.SUPER_ADMIN,
      component: SubscriptionPages,
      documentTitle: "Super Admin",
      pageTitle: "Manager and Create subscription plans",
      pageSubTitle:
        "Create new subscription plans, these will also be created in stripe / shopify and allow you to build contracts for clients, link these subscriptions to contracts. ",
    },
    {
      name: RouteNames.CONTRACTS,
      exact: true,
      path: "/admin/contracts",
      withClients: true,
      minRole: ApiACLRole.SUPER_ADMIN,
      component: ContractsPage,
      documentTitle: "Super Admin",
      pageTitle: "Manager Contracts",
      pageSubTitle: "Build contract terms and conditions.",
    },
    {
      name: RouteNames.PRODUCTS,
      exact: true,
      path: "/admin/products",
      withClients: true,
      minRole: ApiACLRole.SUPER_ADMIN,
      component: ProductsPage,
      documentTitle: "Super Admin",
      pageTitle: "Manager Products",
      pageSubTitle:
        "Products are the basis of subscriptions, they allow you to asign a tier, you then when creating subscriptions attach to a product",
    },
    {
      name: RouteNames.PROJECT_SUBSCRIPTIONS,
      exact: true,
      path: "/admin/project-subscriptions",
      withClients: true,
      minRole: ApiACLRole.SUPER_ADMIN,
      component: ProjectSubscriptionsPage,
      documentTitle: "Super Admin",
      pageTitle: "Manager subscriptions linked to projects",
      pageSubTitle: "Todo",
    },
    {
      name: RouteNames.ANALYTICS_LABELS,
      exact: true,
      path: "/admin/analytics-labels",
      withClients: true,
      minRole: ApiACLRole.SUPER_ADMIN,
      component: AnalyticsLabelsPage,
      documentTitle: "Super Admin",
      pageTitle: "Manager Dimension & Metric Labels",
    },
    {
      name: RouteNames.AI_CREDITS,
      exact: true,
      path: "/admin/ai-credits",
      withClients: true,
      minRole: ApiACLRole.SUPER_ADMIN,
      component: AICreditsPage,
      documentTitle: "Super Admin",
      pageTitle: "AI Credits",
      pageSubTitle: "Configure AI billing items (credits per use) by type.",
    },
    {
      name: RouteNames.ONBOARDING,
      exact: true,
      path: "/admin/onboarding",
      withClients: true,
      minRole: ApiACLRole.SUPER_ADMIN,
      component: OnboardingPage,
      documentTitle: "Super Admin",
      pageTitle: "Project Onboarding",
      pageSubTitle: "Create and Manage Onboarding flows for projects",
    },
    {
      name: RouteNames.NEW_PROJECT,
      exact: true,
      path: "/admin/new-project",
      withClients: true,
      minRole: ApiACLRole.SUPER_ADMIN,
      component: NewProjectPage,
      documentTitle: "Super Admin",
      pageTitle: "Create New Project",
      pageSubTitle: "Create a new project with user and onboarding",
    },
    {
      name: RouteNames.SHARED_COMPONENT_BLOCKS,
      exact: true,
      path: "/admin/shared-component-blocks",
      withClients: true,
      minRole: ApiACLRole.SUPER_ADMIN,
      component: SharedComponentBlocksPage,
      documentTitle: "Super Admin",
      pageTitle: "Shared Component Blocks",
      pageSubTitle: "Manage shared component blocks",
    },
    {
      name: RouteNames.SHARED_COMPONENT_BLOCK,
      exact: true,
      path: "/admin/shared-component-blocks/:componentId",
      withClients: true,
      minRole: ApiACLRole.SUPER_ADMIN,
      component: SharedComponentBlockPage,
      documentTitle: "Super Admin",
      pageTitle: "Shared Component Block",
      breadcrumbComponent: <SharedComponentBlockBreadcrumb />,
    },

    {
      name: RouteNames.ACCOUNT,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/account",
      withClients: true,
      component: AccountPage,
      documentTitle: "Accounts",
      pageTitle: "Manage Your Account",
      minRole: ApiACLRole.PROJECT_ADMIN,
    },
    {
      name: RouteNames.ACCOUNT_USERS,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/account/users",
      withClients: true,
      component: AccountPage,
      documentTitle: "Accounts",
      pageTitle: "My Account",
      minRole: ApiACLRole.PROJECT_ADMIN,
    },
    {
      name: RouteNames.ACCOUNT_USER,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/account/users/:userId",
      withClients: true,
      component: AccountPage,
      documentTitle: "Accounts",
      pageTitle: "My Account",
      minRole: ApiACLRole.PROJECT_ADMIN,
    },
    {
      name: RouteNames.ACCOUNT_PAYMENT,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/account/payment",
      withClients: true,
      component: AccountPage,
      documentTitle: "Accounts",
      pageTitle: "My Account",
      minRole: ApiACLRole.PROJECT_ADMIN,
    },
    {
      name: RouteNames.ACCOUNT_AI,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/account/ai",
      withClients: true,
      component: AccountPage,
      documentTitle: "Accounts",
      pageTitle: "My Account",
      minRole: ApiACLRole.PROJECT_ADMIN,
    },
    {
      name: RouteNames.ACCOUNT_GENERAL,
      exact: true,
      path: "/clients/:clientId/projects/:projectId/account/general",
      withClients: true,
      component: AccountPage,
      documentTitle: "Accounts",
      pageTitle: "My Account",
      minRole: ApiACLRole.PROJECT_ADMIN,
    },
    {
      name: RouteNames.ACCOUNT_ROOT,
      exact: true,
      path: "/account",
      withClients: true,
      component: AccountPage,
      documentTitle: "Accounts",
      pageTitle: "Manage Your Account",
      minRole: ApiACLRole.PROJECT_ADMIN,
    },
    // fall back as be does nto have clientid
    {
      name: RouteNames.THANK_YOU,
      exact: true,
      path: "/accounts/payment/thank-you/:projectId",
      withClients: true,
      component: ThankyouPage,
      documentTitle: "Accounts",
      pageTitle: "My Account",
      minRole: ApiACLRole.PROJECT_ADMIN,
    },
  ] as IProtectedRoute[];

  // Create a named object for easy access
  const routesByName = routes
    .filter((r) => !!r)
    .reduce((acc, route) => {
      acc[route.name] = route;
      return acc;
    });

  const routesByPath = routes
    .filter((r) => !!r)
    .reduce((acc, route) => {
      acc[route.path as string] = route;
      return acc;
    });

  const pathByName = useCallback(
    (name: RouteNames, opts?: Record<string, number | string | undefined>) => {
      const route = routesByName[name];
      if (!route) return "";

      let path = route.path as string;

      // Replace any parameter that matches :paramName with the value from opts
      if (opts) {
        Object.entries(opts).forEach(([key, value]) => {
          if (!value) return;
          const paramPattern = new RegExp(`:${key}`, "g");
          path = path.replace(paramPattern, value.toString());
        });
      }

      return path;
    },
    [routesByName],
  );

  return {
    routes,
    routesByName,
    pathByName,
    routesByPath,
  };
}

export default useProtectedRoutes;
